import Model from '@/models/Model.js';

export default class TimelineCheckpoint extends Model {
    static entity = 'timeline_checkpoints';

    static fields() {
        return {
            id: this.attr(null),
            external_id: this.attr(null),
            timeline_id: this.attr(null),
            timeline_checkpoint_type_id: this.attr(null),
            title: this.string(''),
            description: this.string(null, value => (value === 'null' ? null : value)),
            start_date: this.attr(null),
            end_date: this.attr(null),
            url: this.attr(null),
            is_completed: this.attr(null),
            is_event_accessible: this.attr(null),
            is_live: this.attr(null),
            is_end_date_checkpoint: this.attr(null),
            combine_checkpoints: this.attr(null, value => (value.length > 0 ? [] : value)),
            icon: this.attr(null),
            course_id: this.attr(null),

            checkpointable_type: this.attr(null),
            checkpointable_id: this.attr(null),

            ...super.fields(),

            timeline: this.belongsTo('timelines', 'timeline_id'),
            timeline_checkpoint_type: this.belongsTo('timeline_checkpoint_types', 'timeline_checkpoint_type_id'),
        };
    }

    get short_title() {
        return this.title.length < 30 ? this.title : `${this.title.substring(0, 30)}...`;
    }

    get progress_value_unix_time() {
        return this.is_end_date_checkpoint ? this.timestamp('end_date').unix() : this.timestamp('start_date').unix();
    }

    get progress_value() {
        return this.is_end_date_checkpoint ? this.end_date : this.start_date;
    }

    get checkpoint_date() {
        return this.is_end_date_checkpoint
            ? this.timestamp('end_date').format('LL')
            : this.timestamp('start_date').format('LL');
    }
}
